/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ContactMethodService} from "../../../Services/ContactMethodService";

export class ContactMethodFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			contactMethods: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ContactMethodService.Get()
			.then((x) => {
				this.setState({contactMethods: x.result});
			});
	}

	@autobind
	getStatus() {
		let state = this.state.contactMethods.find((x) => x.contactMethodId == this.props.Value);

		return state;
	}

	@autobind
	_render() {
		return this.getStatus() ? this.getStatus().name : "N/A";
	}
}